import React from 'react';
import { BOLD_FONT } from './BaseElement.jsx';
import { vesselLoadingStatus, railcarLoadingStatus,
  vesselDischargingStatus } from '../../../dict/Enums.js';
import PlaceNameDisplayWrapper from '@/component/dict/simple/port/NameDisplayWrapper';

export const PortElement = (props) => {
  const portId = props.container ? props.portId : props.port.get('place');
  const status = props.container ? props.status : props.port.get('status');
  const eta = props.container ? props.eta : props.port.get('eta');
  const etc = props.container ? '' : props.port.get('etc');
  const sailed = props.container ? props.sailingDate : props.port.get('sailingDate');
  const blDate = props.container ? props.blDate : props.port.get('billLandingDate');

  let ports = vesselDischargingStatus;
  if (props.portType == 'vesselLoadingPorts') {
    ports = vesselLoadingStatus;
  } else if (props.portType == 'railcarLoadingPorts') {
    ports = railcarLoadingStatus;
  }
  return (<div style={props.style}>
    <PlaceNameDisplayWrapper
      prefix={props.prefix}
      id={portId}
      className="text-primary"
      baseStyle={{ display: 'inline', wordBreak: 'break-all',
        whiteSpace: 'normal' }}
      style={{ ...BOLD_FONT, display: 'inline', wordBreak: 'break-all',
        whiteSpace: 'normal' }}
      noBorder={props.noBorder}
    />
    <div style={{ display: 'inline' }}>{' '}
      <span>
        {
          ports.get(status)
        }
      </span>
      {
        status == 'ON_THE_WAY_TO_PORT' && (!props.container
          || (props.container && props.portType == 'vesselDischargePorts'))
          ?
          <span style={{ display: 'block' }}>
            <span
              className="text-primary"
              style={{ ...BOLD_FONT, display: 'inline' }}
            >
              {' ETA '}
            </span>
            <span>{eta}</span>
          </span>
          : ''
      }
      {
        status == 'LOADING_DISCHARGING' && !props.container
          ?
          <span style={{ display: 'block' }}>
            <span
              className="text-primary"
              style={{ ...BOLD_FONT, display: 'inline' }}
            >
              {' ETC '}
            </span>
            <span>{etc}</span>
          </span>
          : ''
      }
      {
        status == 'SAILED'
          ?
          <span>
            <span
              className="text-primary"
              style={{ ...BOLD_FONT, display: 'inline' }}
            >{' '}
            </span>
            <span>{sailed}</span>
          </span>
          : ''
      }
      {
        (status == 'SAILED' || status == 'COMPLETED') && blDate
          ?
          <span style={{ display: 'block' }}>
            <span
              className="text-primary"
              style={{ ...BOLD_FONT, display: 'inline' }}
            >
              {' B/L date '}
            </span>
            <span>{blDate}</span>
          </span>
          : ''
      }
    </div>
  </div>);
};

PortElement.propTypes = {
  port: React.PropTypes.object,
  portType: React.PropTypes.string,
  container: React.PropTypes.bool,
  portId: React.PropTypes.number,
  status: React.PropTypes.string,
  eta: React.PropTypes.string,
  style: React.PropTypes.object,
  sailingDate: React.PropTypes.string,
  blDate: React.PropTypes.string,
  prefix: React.PropTypes.oneOfType(
    [React.PropTypes.string,
      React.PropTypes.object,
    ]),
  noBorder: React.PropTypes.bool,
};
